export default __webpack_public_path__ + "static/media/1773.2bff3ad6.png";